"use strict";

module.exports = function (value) {
	try {
		return value.toString();
	} catch (error) {
		try { return String(value); }
		catch (error2) { return null; }
	}
};



//////////////////
// WEBPACK FOOTER
// ./~/type/lib/safe-to-string.js
// module id = 451
// module chunks = 0